<template>
  <div>
    <div class="results-summary">
        <ListCountResults
            :total-filtered-items="data.Documents.length"
            :total-items="data.TotalResults"
        />
        <span v-if="selectedTypeTags.length > 0 || selectedYearTags.length > 0" class="line"> | </span>
        <button v-if="selectedTypeTags.length > 0 || selectedYearTags.length > 0" class="style-label-underscore clear-filters-desktop" @click="$emit('reset-search-result')">Ryd filtre</button>
    </div>
    <div class="banner-container" v-if="banner && showBanner">
      <div v-html="banner.BannerText"></div>
      <button class="close-button" type="button" @click="showBanner = !showBanner"><span aria-hidden="true">&times;</span></button>
    </div>
    <ul class="news-list">
      <li class="news-item" v-for="item in data.Documents" :key="item.Id"  data-position-related-container>
        <a class="news-card-link" :href="item.Properties.find(prop => prop.Name === 'Uri')?.Value" data-position-related-button>
          <time class="style-single-line">{{ formatDate(item.Properties.find(prop => prop.Name === 'DateTags')?.Value) }}</time>
          <h2 class="result-title style-h5">{{ choosePropertyValue(item, 'PageTitle', 'Title') }}</h2>
          <div v-html="choosePropertyValueMarkup(item, 'Content', 'Description')"></div>
        </a>
      </li>
    </ul>
    <div v-if="data.Documents.length !== data.TotalResults" class="load-more-results">
      <button @click="$emit('fetch-more-content')">Hent flere</button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import ListCountResults from "../listCountResults.vue";
import { initHoverArrowAnimation } from '../../../layout-handlers.js'

// Props
const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  banner: {
    type: Object,
    required: false,
  },
  selectedTypeTags: {
    type: Array,
    required: true
  },
  selectedYearTags: {
    type: Array,
    required: true
  }
})

const showBanner = ref(true)

onMounted(async () => {
  initHoverArrowAnimation();
});

watch(() => props.data, async () => {
  initHoverArrowAnimation();
});

function choosePropertyValue(item, primary, fallback) {
  const primaryValue = item.Properties.find(prop => prop.Name === primary)?.Value
  if (primaryValue && primaryValue.length > 0) {
    return primaryValue
  }
  return item.Properties.find(prop => prop.Name === fallback)?.Value
}

function choosePropertyValueMarkup(item, primary, fallback) {
  const primaryValue = item.Properties.find(prop => prop.Name === primary)?.ValueMarkup
  if (primaryValue && primaryValue.length > 0) {
    return primaryValue
  }
  return item.Properties.find(prop => prop.Name === fallback)?.ValueMarkup
}

function formatDate(dateString) {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("da-DK").format(date)
}
</script>